import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ClientPermissionsFormErrorStatesEnum {
    UpdateUserPermissionsFailed = ErrorStateScheduleEnum.ClientPermissionsFormStatesStartIndex
}
